import { render, staticRenderFns } from "./CustomerReportTab.vue?vue&type=template&id=28720f3f"
import script from "./CustomerReportTab.vue?vue&type=script&lang=js"
export * from "./CustomerReportTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerReportTab.vue?vue&type=style&index=0&id=28720f3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports